import type { KbGapInboxSectionProps } from "./kbGapInboxTypes";

type Props = Pick<
  KbGapInboxSectionProps,
  "gapInboxListTotal" | "gapInboxPageSize" | "gapInboxPage" | "gapInboxLoading" | "onGapInboxPageChange"
>;

export function KbGapInboxPagination(props: Props) {
  if (props.gapInboxListTotal <= props.gapInboxPageSize) return null;
  return (
    <div className="flex flex-wrap justify-center gap-2 pt-2">
      <button
        type="button"
        className="rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-xs text-gray-700 disabled:opacity-40 dark:border-zinc-600 dark:bg-zinc-900/60 dark:text-zinc-200"
        disabled={props.gapInboxPage <= 0 || props.gapInboxLoading}
        onClick={() => props.onGapInboxPageChange(props.gapInboxPage - 1)}
      >
        Previous page
      </button>
      <button
        type="button"
        className="rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-xs text-gray-700 disabled:opacity-40 dark:border-zinc-600 dark:bg-zinc-900/60 dark:text-zinc-200"
        disabled={props.gapInboxLoading || (props.gapInboxPage + 1) * props.gapInboxPageSize >= props.gapInboxListTotal}
        onClick={() => props.onGapInboxPageChange(props.gapInboxPage + 1)}
      >
        Next page
      </button>
    </div>
  );
}
